import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { OffersStats, OffersStatsItem } from '../../components/OffersStats';
import { getOffers } from '../../selectors/offers';

export const OffersStatsContainer = () => {
  const offers = useSelector(getOffers);

  if (!offers.fromDeveloperRooms.length) {
    return null;
  }

  return (
    <Layout dataTestId="offers-stats-seo">
      <UIHeading2>Квартиры в ЖК</UIHeading2>
      <OffersStats>
        {offers.fromDeveloperRooms.map(offer => {
          return (
            <OffersStatsItem
              key={offer.roomTypeDisplay}
              roomType={offer.roomTypeDisplay}
              price2Range={offer.price2Range}
              totalAreaMinDisplay={offer.totalAreaMinDisplay}
              fromDeveloperPropsCount={offer.fromDeveloperPropsCount}
              offersUrl={offer.offersUrl}
            />
          );
        })}
      </OffersStats>
    </Layout>
  );
};
